module.exports = __webpack_public_path__ + "static/media/question.0e684b18.png";